

























































import {
  defineComponent,
  useStore,
  ref,
  onMounted,
} from '@nuxtjs/composition-api'
import { computed } from '@vue/composition-api'
import NavigationLink from '@/components/Navigation/NavigaitionLink.vue'
import BlockSlider from '@/components/BlockSlider.vue'

export default defineComponent({
  name: 'NavigationLinksBlock',
  components: { BlockSlider, NavigationLink },
  props: {
    block: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const store = useStore()
    const isMobile = computed<boolean>(
      (): boolean => store.getters['mediaQuery/isMobileMq']
    )
    const scrollable = ref(null)
    const hasScroll = ref(false)
    const slider = ref(null)
    const limit = ref({ min: false, max: false })
    const hasSlider = computed(() => {
      return !isMobile.value && hasScroll.value
    })
    const onPrevious = () => {
      slider.value?.goToPrevious()
    }
    const onNext = () => {
      slider.value?.goToNext()
    }
    const onLimit = (value) => {
      limit.value = { ...value }
    }
    onMounted(() => {
      setTimeout(() => {
        if (scrollable.value) {
          hasScroll.value =
            scrollable.value.scrollWidth > scrollable.value.clientWidth
        }
      })
    })
    return {
      onPrevious,
      onNext,
      slider,
      limit,
      onLimit,
      scrollable,
      hasSlider,
      isMobile,
    }
  },
})
